import { Button } from 'antd';
import React from 'react';

export const ServicesViewScreen = () => {
    return <>
        <span className='self-center' >Services</span>
        <span className='self-center w-1/3 text-center  my-10' >Interested in Move Your Car full list of services? follow the link below</span>
        <Button className='self-center px-10' type='primary'>View Website</Button>
    </>
}